import * as interfaces from './interfaces.js'
import * as models from './models.js'
import { createIcons, createElement, Speech, Ellipsis, Undo2 } from 'lucide';
import { ArrowUp, Pencil, Bug } from 'lucide-static';
import * as events from './events.js'
import * as handlers from './event-handlers.js'

type EventHandler = (event) => void;

export class AppContainer {
    static getElement() {
        return document.getElementById('app-container')
    }
}

export class ContentArea {
    createElement() {
        const area = document.createElement('div')
        area.id = "repetition-area"
        return area
    }

    static getElement() {
        return document.getElementById('repetition-area')
    }

    static getReps() {
        return document.querySelectorAll('.repetition');
    }

    static getRepOnView() {
        const repArea = ContentArea.getElement()
        const reps = Array.from(ContentArea.getReps())
        // console.log(reps)
        const visibleReps = reps.filter((rep) => rep.style.display != 'none')

        if (visibleReps.length > 1) {
            throw Error("Couldn't resolve which repetition is on view because multiple were found.")
        } else if (visibleReps.length == 0) {
            throw Error("Couldn't find any repetition on view")
        }
        return visibleReps[0]
    }

    static getLastRep() {
        const reps = ContentArea.getReps()
        return reps[reps.length - 1]
    }

    static getSecondLastRep() {
        const reps = ContentArea.getReps()
        return reps[reps.length - 2]
    }
}

export class ReceivedWrapper {
    createElement() {
        const wrapper = document.createElement('div')
        wrapper.className = 'received-wrapper'
        return wrapper
    }
    
}

export class ReceivedMessageWrapper {
    createElement() {
        const container = document.createElement('div')
        container.className = 'received-message-wrapper'
        return container
    }
}

export class ReceivedMessage {
    createElement(messageContent: string) {
        const container = document.createElement('div')
        container.className = 'message'
        container.textContent = messageContent
        return container
    }
}

export class Start {
    #event;
    constructor(event: Event) {
        this.#event = event
    }
    createElement(messageContent: string, buttonContent: string) {
        const container = document.createElement('div')
        container.id = 'start'
        container.innerHTML = messageContent //`Você tem ${cardCount} cartões<br>para praticar hoje.`
        const startButton = this.#startButton(buttonContent)
        startButton.addEventListener('click', () => {
            document.dispatchEvent(new this.#event())
        })
        container.append(startButton)
        return container
    }

    static getElement() {
        return document.getElementById('start')
    }

    #startButton(buttonContent: string) {
        const button = document.createElement('button')
        button.textContent = buttonContent // 'começar'
        button.id = 'start-btn'
        return button
    }
}

export class FatalError {
    createElement(message: string) {
        const container = document.createElement('div')
        container.id = 'fatal-error'
        container.innerHTML = `<center>${Bug}</center><br>${message}`
        return container
    }
}

export class AllDone {
    createElement() {
        const container = document.createElement('div')
        container.id = 'start'
        container.innerHTML = 'All done for today!<br>Por hoje é isso!'
        return container
    }
}

export class Card {
    _footer; _sentence; _focus
    constructor(
        focus: CardFocus,
        sentence: CardSentence,
        footer: CardFooter
    ) {
        this._focus = focus
        this._sentence = sentence
        this._footer = footer
    }

    createElement(rep: models.Repetition) {
        const cardContainer = this._createCardContainer()
        const heading = this._createHeading(rep)
        const content = this._createContentContainer()
        const focus = this._focus.createElement(rep.card.focus, rep.card.ipa)
        const phrase = this._sentence.createElement(rep.card.phrase)
        const footer = this._footer.createElement(rep.card)

        content.appendChild(focus)
        if (rep.card.type == "sentence section") {
            content.appendChild(phrase)
        }
        cardContainer.appendChild(heading)
        cardContainer.appendChild(content)
        cardContainer.appendChild(footer)

        return cardContainer
    }


    _createCardContainer() {
        const container = document.createElement('div')
        container.className = 'card'
        return container
    }

    _createHeading(rep) {
        const heading = document.createElement('div')
        heading.className = 'card-heading'
        heading.textContent = rep.skillStageLabel
        return heading
    }

    _createContentContainer() {
        const container = document.createElement('div')
        container.className = 'card-content'
        return container
    }
}

export class AnswerCard extends Card {
    createElement(card: models.CardBack): HTMLDivElement {
        // console.log('creating answeer card', card)
        const cardContainer = this._createCardContainer()
        const heading = this._createHeading()
        const content = this._createContentContainer()
        // const focus = this._focus.createElement(card.focus, '')
        const footer = this._footer.createElement(card)

        const translations = document.createElement('div')
        translations.className = 'translations-wrapper'
        card.translations.forEach((t) => {
            const translation = this._sentence.createElement(t)
            // translation.textContent = t
            translations.appendChild(translation)
        })

        // content.appendChild(focus)
        content.appendChild(translations)
        cardContainer.appendChild(heading)
        cardContainer.appendChild(content)
        cardContainer.appendChild(footer)

        return cardContainer
    }

    _createHeading(rep) {
        const heading = document.createElement('div')
        heading.className = 'card-heading'
        heading.textContent = 'Resposta'
        return heading
    }
}



export class CardFocus {

    createElement(focusContent: string, ipaContent: string) {
        const wrapper = this.#createWrapper()
        const focus = this.#createFocus('focus')
        focus.textContent = focusContent
        const ipa = this.#createIPA('/ipa/')
        ipa.textContent = ipaContent
        wrapper.appendChild(focus)
        wrapper.appendChild(ipa)
        return wrapper
    }

    #createWrapper() {
        const focusWrapper = document.createElement('div')
        focusWrapper.className = 'focus-wrapper'
        return focusWrapper
    }

    #createFocus(content: string) {
        const focus = document.createElement('div')
        focus.className = 'focus'
        focus.textContent = content
        return focus
    }

    #createIPA(content: string) {
        const ipa = document.createElement('div')
        ipa.className = 'ipa'
        ipa.textContent = content
        return ipa
    }
}


export class CardSentence {
    createElement(sentenceTextContent: string) {
        const wrapper = this.#createWrapper()
        const container = this.#createContainer(sentenceTextContent)
        wrapper.appendChild(container)
        return wrapper
    }

    #createWrapper() {
        const sentenceWrapper = document.createElement('div')
        sentenceWrapper.className = 'focus-wrapper'
        return sentenceWrapper
    }

    #createContainer(sentenceTextContent: string) {
        const sentence = document.createElement('div')
        sentence.className = 'example-sentence'
        sentence.innerHTML = sentenceTextContent
        return sentence
    }
}



export class CardFooter {

    createElement(card:models.Card) {
        const footer = this.#createContainer()
        if (card.has_audio) {
            const soundButton = this.#createSoundButton()
            soundButton.addEventListener('click', () => {
                card.play_audio()
            })
            footer.appendChild(soundButton)
        }
        return footer
    }

    #createContainer() {
        const footer = document.createElement('div')
        footer.className = 'card-footer'
        return footer
    }

    #createSoundButton() {
        const soundButton = document.createElement('div')
        soundButton.className = 'play-button'
        // soundButton.textContent = '@'
        const shadowRoot = soundButton.attachShadow({mode: "open"})
        const icon = createElement(Speech)
        shadowRoot.appendChild(icon)
        return soundButton
    }
}



// export class 



export class Repetition {
    #receivedWrapper; #prompt; #card
    className = 'repetition'
    constructor(
        receivedWrapper: ReceivedWrapper,
        prompt: ReceivedMessage,
        card: Card
    ) {
        this.#receivedWrapper = receivedWrapper
        this.#prompt = prompt
        this.#card = card
    }

    // createElement(id: number, promptContent: string, phraseContent: string) {
    createElement(rep: models.Repetition) {
        const repWrapper = document.createElement('div')
        repWrapper.className = Repetition.className
        repWrapper.id = rep.id.toString()
        const receivedWrapper = this.#receivedWrapper.createElement()
        const prompt = this.#prompt.createElement(rep.card.prompt)
        const card = this.#card.createElement(rep)
        receivedWrapper.appendChild(prompt)
        receivedWrapper.appendChild(card)
        repWrapper.append(receivedWrapper)
        return repWrapper
    }

    static get className(): string {
        return 'repetition'
    }


}



export class ContextMenu {
    #handler
    constructor(handler) {
        this.#handler = handler
    }
    createElement(x, y) {
        const menu = document.createElement('div')
        menu.className = 'context-menu'
        menu.innerHTML = `
        <button>Acho que acertei</button> 
        ` // this has side effects on the handler
        menu.style.position = 'fixed'
        menu.style.left = x + 'px'
        menu.style.top = y + 'px'

        menu.addEventListener('click', (event) => {
            menu.remove();
            this.#handler.handle(event)
        })
        
        document.addEventListener('click', () => menu.remove(), { once: true })

        return menu
    }
}



export class EllipsisButton {
    createElement() {
        const button = document.createElement('div')
        button.className = 'ellipsis-button'
        // const shadowRoot = button.attachShadow({mode: "open"})
        const icon = createElement(Ellipsis)
        button.appendChild(icon)
        // shadowRoot.appendChild(icon)
        return button
    }
}

export class ReturnRepButton {
    #handler
    constructor(
        handler: handlers.ReturnRep
    ) {
        this.#handler = handler
    }
    createElement() {
        const button = document.createElement('div')
        button.className = 'custom-button'
        button.id = 'rep-return'
        const icon = createElement(Undo2)
        button.appendChild(icon)
        // button.innerHTML = ArrowUp
        button.addEventListener('click', this.#handler)
        return button
    }

    static get elementId() {
        return 'rep-return'
    }

    static getElement() {
        return document.getElementById(ReturnRepButton.elementId)
    }

    // static hide() {
    //     const button = ReturnRepButton.getElement()
    //     button.style.display = 'none'
    // }
}


// export class IncorrectAnswerContextMenu {
//     constructor(

//     )
// }


export class Result {
    #message; #card; #messageWrapper; #ellipsis; #contextMenu
    constructor(
        // receivedWrapper: ReceivedWrapper,
        messageWrapper: ReceivedMessageWrapper,
        message: ReceivedMessage,
        ellipsis: EllipsisButton,
        contextMenu: ContextMenu,
        card: AnswerCard
    ) {
        this.#messageWrapper = messageWrapper
        this.#message = message
        this.#ellipsis = ellipsis
        this.#contextMenu = contextMenu
        this.#card = card
    }

    // createElement(resultCode: string, answerCard: models.AnswerCard) {
    createElement(rep: models.Repetition) {
        const resultWrapper = document.createElement('div')
        resultWrapper.className = 'result-wrapper'
        const results = {
            "-1": 'Veja a resposta:',
            "0": 'Incorreto!',
            "1": 'Correto!'
        }
        // const messageTextContent = results[resultCode]
        const messageTextContent = results[rep.resultCode]
        const messageWrapper = this.#messageWrapper.createElement()
        const message = this.#message.createElement(messageTextContent)
        const card = this.#card.createElement(rep.card.createCardBack())
        messageWrapper.append(message)
        if (rep.resultCode == "0") {
            const ellipsis = this.#createEllipsis()
            messageWrapper.append(ellipsis)
        }
        resultWrapper.appendChild(messageWrapper)
        resultWrapper.appendChild(card)
        return resultWrapper
    }

    #createEllipsis() {
        const ellipsis = this.#ellipsis.createElement()
        ellipsis.addEventListener('click', (event) => {
            this.#showContextMenu(event)
        })
        return ellipsis
    }

    #showContextMenu(event) {
        event.stopPropagation()
        const menu = this.#contextMenu.createElement(
                event.clientX, event.clientY)
        document.body.appendChild(menu)
    }


}




export class AnswerBox {
    #eventHandler; #textArea; #dontKnowButton; #sendButton
    constructor(
        eventHandler: EventHandler,
        textarea: AnswerTextArea,
        dontKnowButton: DontKnowButton,
        sendButton: SendButton
    ) {
        this.#eventHandler = eventHandler;
        this.#textArea = textarea;
        this.#dontKnowButton = dontKnowButton
        this.#sendButton = sendButton
    }

    createElement() {
        const answerBox = this.#createAnswerBoxWrapper()
        const textarea = this.#textArea.createElement()
        const buttonRow = this.#createButtonRow()
        const dontKnowButton = this.#dontKnowButton.createElement()
        const sendButton = this.#sendButton.createElement()

        buttonRow.appendChild(dontKnowButton)
        buttonRow.appendChild(sendButton)
        answerBox.appendChild(textarea)
        answerBox.appendChild(buttonRow)

        const handler = this.#eventHandler
        answerBox.addEventListener('click', handler)
        answerBox.addEventListener('input', handler)
        answerBox.addEventListener('keydown', handler)

        return answerBox
    }

    static getElement() {
        return document.getElementById('input-box-wrapper')
    }

    #createAnswerBoxWrapper() {
        const inputBox = document.createElement('div')
        inputBox.id = 'input-box-wrapper'
        return inputBox
    }

    #createButtonRow() {
        const buttonRow = document.createElement('div')
        buttonRow.className = 'button-row'
        return buttonRow
    }

    // #createSendButton() {
    //     const sendButton = document.createElement('button')
    //     sendButton.type = 'submit'
    //     sendButton.textContent = '↑'
    //     sendButton.id = 'send-btn'
    //     sendButton.disabled = true
    //     return sendButton
    // }
}

export class ActionBar {
    createElement() {
        const buttonRow = document.createElement('div')
        buttonRow.className = 'action-bar'
        buttonRow.id = ActionBar.elementId
        return buttonRow
    }

    static get elementId() {
        return 'action-bar'
    }

    static getElement() {
        return document.getElementById(ActionBar.elementId)
    }
}


// const button = document.createElement('div')
//         button.className = 'custom-button'
//         button.id = 'rep-return'
//         const icon = createElement(Undo2)
//         button.appendChild(icon)
//         button.addEventListener('click', this.#handler)
//         return button

export class SendButton {
    constructor(private event: typeof events.AnswerSubmitted) {
        this.event = event
    }
    createElement() {
        // ArrowUp
        const sendButton = document.createElement('button')
        sendButton.type = 'submit'
        // sendButton.textContent = '↑'
        sendButton.id = 'send-btn'
        sendButton.disabled = true
        sendButton.innerHTML = ArrowUp

        sendButton.addEventListener('click', () => {
            document.dispatchEvent(new this.event())
        });
        // sendButton.innerHTML = '↑'

        // const icon = createElement(ArrowUp)
        // sendButton.appendChild(icon)

        // const icon = document.createElement('i')
        // icon.setAttribute('data-lucide', 'arrow-up')
        // sendButton.appendChild(icon)

        // createIcons({
        //     icons: {
        //         ArrowUp
        //     }
        // })

        return sendButton
    }

    static getElement() {
        return document.getElementById('send-btn')
    }
}

export class AnswerTextArea {
    createElement() {
        const input = document.createElement('input')
        input.id = 'answer-input'
        input.type = 'text'
        input.name = 'answer'
        input.placeholder = 'Digite a resposta'
        input.maxLength = 30
        input.addEventListener('keydown', function(e) {
            if (/[0-9]/.test(e.key)) {
                e.preventDefault();
            }
        });
        return input
    }

    static getElement() {
        return document.getElementById('answer-input')
    }
}

export class DontKnowButton {
    #label; #input
    constructor(label: DontKnowLabel, input: DontKnowInput) {
        this.#label = label
        this.#input = input
    }

    createElement() {
        const dontKnowButton = document.createElement('div')
        dontKnowButton.id = 'dont-know-btn'
        const label = this.#label.createElement()
        const input = this.#input.createElement()

        // const label = document.createElement('label')
        // label.textContent = 'Não faço ideia'
        // label.htmlFor = 'dont-know'
        // const input = document.createElement('input')
        // input.type = 'checkbox'
        // input.id = 'dont-know'
        // input.value = "0"
        // input.name = "dont-know"

        dontKnowButton.appendChild(input)
        dontKnowButton.appendChild(label)

        // dontKnowButton.id = 'dont-know-btn'
        return dontKnowButton
    }

    static getElement() {
        return document.getElementById('dont-know-btn')
    }
}

export class DontKnowLabel {
    createElement() {
        const label = document.createElement('label')
        label.textContent = 'Não faço ideia'
        label.htmlFor = 'dont-know-input'
        label.id = "dont-know-label"
        return label
    }

    static getElement() {
        return document.getElementById('dont-know-label')
    }
}

export class DontKnowInput {
    createElement() {
        const input = document.createElement('input')
        input.type = 'checkbox'
        input.id = 'dont-know-input'
        input.value = ""
        input.name = "dont-know-input"
        return input
    }

    static getElement() {
        return document.getElementById('dont-know-input')
    }
}



export class RatingOptions {
    #handler
    constructor(handler: EventHandler) {
        this.#handler = handler
    }

    createElement() {
        const groupContainer = document.createElement('div')
        groupContainer.className = 'radio-group-container'
        groupContainer.id = 'rating-box'

        const hardInput = document.createElement('input')
        hardInput.type = 'radio'
        hardInput.id = 'rating-2'
        hardInput.name = 'rating'
        hardInput.value = '2'

        const hardLabel = document.createElement('label')
        hardLabel.htmlFor = 'rating-2'
        hardLabel.id = 'rating-2-label'
        hardLabel.textContent = 'difícil'

        const okayInput = document.createElement('input')
        okayInput.type = 'radio'
        okayInput.id = 'rating-3'
        okayInput.name = 'rating'
        okayInput.value = '3'

        const okayLabel = document.createElement('label')
        okayLabel.htmlFor = 'rating-3'
        okayLabel.id = 'rating-3-label'
        okayLabel.textContent = 'mais ou menos'

        const easyInput = document.createElement('input')
        easyInput.type = 'radio'
        easyInput.id = 'rating-4'
        easyInput.name = 'rating'
        easyInput.value = '4'

        const easyLabel = document.createElement('label')
        easyLabel.htmlFor = 'rating-4'
        easyLabel.id = 'rating-4-label'
        easyLabel.textContent = 'fácil'

        const elements = [
            hardInput, hardLabel,
            okayInput, okayLabel,
            easyInput, easyLabel
        ]

        elements.forEach(element => {
            groupContainer.appendChild(element)
        })
        
        groupContainer.addEventListener('input', this.#handler)

        return groupContainer

    }

    static getElement() {
        return document.getElementById('rating-box')
    }

}



export class AnswerInputMessage {
    createElement(content: string) {
        // const area = document.getElementById('card-area')
        const wrapper = this.#createMessageWrapper()
        const container = this._createMessageContainer(content)

        wrapper.appendChild(container)
        // area?.appendChild(wrapper)
        return wrapper
    }

    #createMessageWrapper() {
        const wrapper = document.createElement('div')
        wrapper.className = 'message-wrapper'
        return wrapper
    }

    _createMessageContainer(content: string) {
        const container = document.createElement('div')
        container.className = 'sent-message'
        container.textContent = content
        return container
    }
}


export class RatingHardMessage extends AnswerInputMessage {
    _createMessageContainer(content: string) {
        const message = document.createElement('div')
        message.className = 'sent-message rating hard'
        message.textContent = content
        return message
    }
}

export class RatingOkayMessage extends AnswerInputMessage {
    _createMessageContainer(content: string) {
        const message = document.createElement('div')
        message.className = 'sent-message rating okay'
        message.textContent = content
        return message
    }
}

export class RatingEasyMessage extends AnswerInputMessage {
    _createMessageContainer(content: string) {
        const message = document.createElement('div')
        message.className = 'sent-message rating easy'
        message.textContent = content
        return message
    }
}


export class ContinueButton {
    #event;
    constructor(event: Event) {
        this.#event = event
    }

    createElement() {
        const button = document.createElement('button')
        button.textContent = 'continuar'
        button.id = 'continue-btn'
        button.addEventListener('click', () => {
            document.dispatchEvent(new this.#event())
        });
        return button
    }

    static getElement() {
        return document.getElementById('continue-btn')
    }
}

export class Loader {

    createElement() {
        const loader = document.createElement('div')
        loader.className = 'loader'
        let dots = []
        Array(3).fill().forEach(() => {
            const dot = document.createElement('div')
            dot.className = 'dot'
            loader.appendChild(dot)
            dots.push(dot)
        });

        let currentDot = 0;
        setInterval(() => {
            // Remove active class from all dots
            dots.forEach(dot => dot.classList.remove('active'));

            // Add active class to current dot
            dots[currentDot].classList.add('active');

            // Move to next dot
            currentDot = (currentDot + 1) % dots.length;
        }, 250);
        return loader
    }
}


export class EditRatingButton  {
    constructor(private handler:handlers.EditRating) {
        this.handler = handler
    }
    createElement() {
        const button = document.createElement('div')
        button.className = 'custom-button'
        button.id = 'edit-rating'
        button.innerHTML = Pencil
        button.addEventListener('click', this.handler)
        return button
    }
}